module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"contentDetailsTabs":{"episodesAndMovies":"Episodes & Movies","extras":"Extras","details":"Details"}},"es":{"contentDetailsTabs":{"episodesAndMovies":"Episodios y películas","extras":"Extras","details":"Detalles"}},"pt":{"contentDetailsTabs":{"episodesAndMovies":"Episódios e filmes","extras":"Extras","details":"Detalhes"}}}')
  delete Component.options._Ctor
}
